import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=cf15265e&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=js&"
export * from "./Scene.vue?vue&type=script&lang=js&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=cf15265e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf15265e",
  null
  
)

export default component.exports